"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _pusherJs = _interopRequireDefault(require("pusher-js"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _actions = require("./actions");

var _BetbarUpper = _interopRequireDefault(require("./BetbarUpper"));

var _BetbarUpperDpg = _interopRequireDefault(require("./BetbarUpperDpg"));

var _BetbarUpperHelp = _interopRequireDefault(require("./BetbarUpperHelp"));

var _BetbarMiddle = _interopRequireDefault(require("./middle/BetbarMiddle"));

var _BetbarLower = _interopRequireDefault(require("./BetbarLower"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: ", ";\n  top: ", "px;\n  left: 0;\n  width: 100%;\n  background: ", ";\n  color: ", ";\n  box-shadow: 0px 0px 10px ", ";\n\n  @media (min-width: ", ") {\n    width: ", ";\n    left: 50%;\n    transform: translateX(-50%);\n  }\n"])), function (p) {
  return p.zIndex;
}, function (p) {
  return p.theme.topbarHeight;
}, function (p) {
  return !p.isLeaderboard ? p.theme.colorBetbarBackground : p.theme.colorBetbarBackgroundLeaderboard;
}, function (p) {
  return p.isLeaderboard ? "rgba(255,255,255,0.96)" : "white";
}, (0, _polished.rgba)("black", 0.1), function (props) {
  return props.theme.screenWidthMd;
}, function (props) {
  return props.theme.railWidth;
});

var StyledLabel = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 0 0 50px;\n  font-size: 0.875rem;\n  color: ", ";\n  text-align: ", ";\n"])), function (p) {
  return p.theme.colorLabel;
}, function (p) {
  return p.isRight ? "right" : "left";
});

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      isDpg = _ref.isDpg,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages,
      betbarParent = _ref.betbarParent,
      setBetbarParent = _ref.setBetbarParent,
      app = _ref.app,
      setApp = _ref.setApp,
      setContest = _ref.setContest,
      getLeaderboard = _ref.getLeaderboard,
      onClearButtonClicked = _ref.onClearButtonClicked,
      onHelpButtonClicked = _ref.onHelpButtonClicked,
      onLoginButtonClicked = _ref.onLoginButtonClicked,
      onLogoutButtonClicked = _ref.onLogoutButtonClicked,
      onSignupButtonClicked = _ref.onSignupButtonClicked,
      history = _ref.history,
      isLeaderboard = _ref.isLeaderboard,
      isLoggedIn = _ref.isLoggedIn,
      test = _ref.test,
      progressTotal = _ref.progressTotal,
      progressCurrent = _ref.progressCurrent,
      hideHelp = _ref.hideHelp,
      hideLeaderboardRow = _ref.hideLeaderboardRow,
      disableDropdown = _ref.disableDropdown,
      showNavigationArrows = _ref.showNavigationArrows,
      showOnlyFixture = _ref.showOnlyFixture,
      showLoginButton = _ref.showLoginButton,
      brandingImageUrl = _ref.brandingImageUrl;
  var dispatch = (0, _reactRedux.useDispatch)();
  var betbar = (0, _reactRedux.useSelector)(function (s) {
    return s.betbar;
  });
  var activePickem = betbar.activePickem,
      activePickemList = betbar.activePickemList,
      activeBet = betbar.activeBet,
      isBetsOpen = betbar.isBetsOpen,
      isActive = betbar.isActive,
      isActivePickemApproved = betbar.isActivePickemApproved;
  var pusher, channel;
  var hasReadBetbarHelp = app.hasReadBetbarHelp; // const isLoading = !activePickem?.id;
  // let isLoadingBet = !activeBet?.betId;

  var onLeaderboardUpdated = function onLeaderboardUpdated(response) {
    console.log("onLeaderboardUpdated", response);
    dispatch((0, _actions.handleLeaderboardUpdated)(response, activeBet === null || activeBet === void 0 ? void 0 : activeBet.betId, setBetbarParent));
  };

  var onQuestionUpdated = function onQuestionUpdated(response) {
    console.log("onQuestionUpdated", response);
    dispatch((0, _actions.handleQuestionUpdated)(response.pickem, setBetbarParent));
  };

  (0, _react.useEffect)(function () {
    if (activePickem !== null && activePickem !== void 0 && activePickem.id) {
      pusher = new _pusherJs.default(process.env.REACT_APP_IS_LIVE === "false" ? process.env.REACT_APP_PUSHER_DEV_KEY : process.env.REACT_APP_PUSHER_LIVE_KEY, {
        cluster: "eu"
      });
      channel = pusher.subscribe("Pickem.".concat(activePickem === null || activePickem === void 0 ? void 0 : activePickem.id));

      if (channel) {
        channel.bind("PickemLeaderboardUpdated", onLeaderboardUpdated);
        channel.bind("PickemQuestionUpdated", onQuestionUpdated);
        console.log("pusher channel", channel);
      }
    }

    return function () {
      var _channel;

      return channel && ((_channel = channel) === null || _channel === void 0 ? void 0 : _channel.unbind());
    };
  }, [activePickem === null || activePickem === void 0 ? void 0 : activePickem.id]);
  (0, _react.useEffect)(function () {
    if (!(activePickem !== null && activePickem !== void 0 && activePickem.id)) {
      dispatch((0, _actions.getBetbar)(setBetbarParent));
    }
  }, [activePickem === null || activePickem === void 0 ? void 0 : activePickem.id]);
  (0, _react.useEffect)(function () {
    if (isLoggedIn) {
      dispatch((0, _actions.getBetbar)(setBetbarParent));
    }
  }, [isLoggedIn]);
  (0, _react.useEffect)(function () {
    if (JSON.stringify(betbarParent) !== JSON.stringify(betbar)) {
      dispatch((0, _actions.setBetbar)(betbarParent));
    }
  }, [betbarParent]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!hideHelp && /*#__PURE__*/(0, _jsxRuntime.jsx)(_BetbarUpperHelp.default, {
      app: app,
      setApp: setApp,
      isLeaderboard: isLeaderboard
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
      isLeaderboard: isLeaderboard,
      zIndex: !hasReadBetbarHelp && (activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.length) > 1 ? 9 : 3,
      children: [isDpg && !isLeaderboard ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_BetbarUpperDpg.default, {
        showLoginButton: showLoginButton,
        onHelpButtonClicked: onHelpButtonClicked,
        onClearButtonClicked: onClearButtonClicked,
        onLoginButtonClicked: onLoginButtonClicked,
        onLogoutButtonClicked: onLogoutButtonClicked,
        onSignupButtonClicked: onSignupButtonClicked,
        translations: translations,
        progressTotal: progressTotal,
        isLoggedIn: isLoggedIn,
        progressCurrent: progressCurrent
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_BetbarUpper.default, {
        setBetbarParent: setBetbarParent,
        disableDropdown: disableDropdown,
        showNavigationArrows: showNavigationArrows,
        isUsingAlternativeImages: isUsingAlternativeImages,
        isDpg: isDpg,
        app: app,
        showOnlyFixture: showOnlyFixture,
        brandingImageUrl: brandingImageUrl
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BetbarMiddle.default, {
        history: history,
        setBetbarParent: setBetbarParent,
        isActive: isBetsOpen,
        setContest: setContest,
        getLeaderboard: getLeaderboard
      }), isLeaderboard && isActivePickemApproved === false && !hideLeaderboardRow && isBetsOpen === false && /*#__PURE__*/(0, _jsxRuntime.jsx)(_BetbarLower.default, {
        history: history,
        app: app
      })]
    })]
  });
};

var _default = Wrapper;
exports.default = _default;